import { render, staticRenderFns } from "./YesNoNotesFilesProps.vue?vue&type=template&id=c6aa58ac"
import script from "./YesNoNotesFilesProps.vue?vue&type=script&lang=js"
export * from "./YesNoNotesFilesProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports